<template>
  <div class="bg-gray-50 px-4 py-6 sm:px-6">
    <div class="flex space-x-3">
      <div class="flex-shrink-0">
        <div v-if="user.image">
          <img :src="user.image.image_uri" :alt="user.name" class="image"/>
        </div>
        <div v-else="user.image">
          <ProfileIconSvg class="image" />
        </div>
      </div>
      <div class="min-w-0 flex-1">
        <div>
          <label for="content" class="sr-only">
            Kommentar
          </label>
          <textarea id="content" v-model="resource.content" rows="3" placeholder="Füge einen Kommentar hinzu..." :class="{'input-error': failed}"/>
        </div>
        <div class="mt-3 flex items-center justify-end">
          <SubmitButton @click="onSubmit" :load="creating">
            Kommentieren
          </SubmitButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useCreateResource } from '@/client/actions';

const props = defineProps({experiment: Object});
const emits = defineEmits(['updated']);
const store = useStore();

const user = computed(() => store.getters['auth/user']);
const parent = computed(() => props.experiment.id);
const target = computed(() => '/api/experiments/' + parent.value + '/comments');
const failed = computed(() => Boolean(errors?.value?.content));

const action = useCreateResource(target);

const { resource, create, creating, errors } = action;

const emit = () => emits('updated');
const reset = () => resource.comment = '';

const onSuccess = () => {emit(); reset()};
const onSubmit = () => create(onSuccess);
</script>

<style scoped>
textarea
{
  @apply block w-full rounded-md shadow-sm;
  @apply border-gray-300;
  @apply focus:border-blue-500;
  @apply focus:ring-blue-500;
  @apply sm:text-sm;
};

.image
{
  @apply h-10 w-10;
  @apply border;
  @apply rounded-full;
};
</style>
